import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaUsers } from "react-icons/fa";
import SamparkAdminLayout from "../../components/SamparkAdminLayout/SamparkAdminLayout.js";
import axios from "axios";

export default function SamparkAdminDashboard() {
  const apiURL = process.env.REACT_APP_API_URL;
  const [samparks, setSamparks] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "SamparkAdmin") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    // Listen for back navigation
    const handleBeforeUnload = () => {
      localStorage.clear();
    };

    // Adding event listener for back navigation
    window.addEventListener("popstate", handleBeforeUnload);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("popstate", handleBeforeUnload);
    };
  }, [navigate]);

  useEffect(() => {
    if (!localStorage.getItem("alertShown")) {
      toast.success("Login successfully");
      localStorage.setItem("alertShown", "true");
    }
  }, []);

  useEffect(() => {
    fetchRecords();
  }, []);

  const fetchRecords = async () => {
    try {
      const response = await axios.get(`${apiURL}/SamparkEmploye/Get`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const data = response.data.data || [];
      setSamparks(data);
      console.log(`Samparks: ${samparks}`);
    } catch (error) {
      console.log(`error.response?.data?.message`);
    }
  };

  useEffect(() => {
    console.log("Updated Samparks:", samparks);
  }, [samparks]);

  return (
    <SamparkAdminLayout ac1="active" ac19="active" samparks={samparks}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h4 className="m-0 text-dark">Dashboard</h4>
            </div>
          </div>
        </div>
      </div>
      <section className="content mb-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/manage-haribhakt4" className="text-dark" state={{ samparks: samparks }}>
                <div className="info-box mb-3">
                  <span className="info-box-icon bg-warning elevation-1">
                    <FaUsers />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">
                      Haribhakt Details
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </SamparkAdminLayout>
  );
}
